module.exports = __webpack_public_path__ + "img/earbuds.8f5d6c64.svg";